export default "71871:890:P, 72004:150:P, 71840:498:P, CONFIG.3743586, CONFIG.2866751\n";